module.exports = __webpack_public_path__ + "static/media/car4.bfa147af.png";